import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ServiceMasterCategoryModel, ServiceModel } from 'src/app/store/self-diagnostic/service-catalog/model';
import { List } from '../../../../../../core/infrastructure/linq';
import { ServiceCatalogFacade } from '../../../../../../store/self-diagnostic/service-catalog/facade';
import { DialogEditIconComponent } from '../../dialogs/dialog-edit-icon/dialog-edit-icon.component';
import { UserModel } from '../../../../../../store/user/model';
import { AppConstants } from '../../../../../../core/constants/app-constants';
import { UserFacade } from '../../../../../../store/user/facade';

@Component({
  selector: 'service-catalog-master-categories',
  templateUrl: './service-catalog-master-categories.component.html',
  styleUrls: ['./service-catalog-master-categories.component.scss'],
  host: {
    class: 'p-4',
  },
  standalone: false,
})
export class ServiceCatalogMasterCategoriesComponent implements OnInit {
  translate = inject(TranslateService);
  private facade = inject(ServiceCatalogFacade);
  sanitizer = inject(DomSanitizer);
  private titleService = inject(Title);
  private userFacade = inject(UserFacade);

  public masterCategories: ServiceMasterCategoryModel[] = [];
  @ViewChild(DialogEditIconComponent) dialogEditIcon: DialogEditIconComponent;
  public user: UserModel;
  public isLanguageUa: boolean;

  public async ngOnInit() {
    // Page title
    this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });

    // Get current language
    this.userFacade.selected().subscribe(user => {
      this.user = { ...user };

      this.isLanguageUa = !this.user?.language || this.user?.language == AppConstants.LANGUAGE_UK;
    });

    this.facade.entities$.subscribe(s$ => {
      this.masterCategories = new List<ServiceModel>(s$)
        .Select(s => s.category)
        .Where(sc => sc.masterCategory != null)
        .Select(sc => sc.masterCategory)
        .DistinctBy(mc => mc.code)
        .OrderByDescending(mc => mc.priority)
        .ThenBy(mc => mc.nameUa)
        .Select(
          mc =>
            <ServiceMasterCategoryModel>{
              id: mc.id,
              nameUa: mc.nameUa,
              nameRu: mc.nameRu,
              code: mc.code,
              priority: mc.priority,
              iconBody: mc.iconBody,
              iconType: mc.iconType,
            }
        )
        .ToArray();
    });
  }

  public upPriority($event) {
    let masterCategory = <ServiceMasterCategoryModel>$event.data;

    this.facade.upPriorityMasterCategory(masterCategory);
  }

  public downPriority($event) {
    let masterCategory = <ServiceMasterCategoryModel>$event.data;

    this.facade.downPriorityMasterCategory(masterCategory);
  }

  public uploadIcon($event) {
    let masterCategory = <ServiceMasterCategoryModel>$event.data;

    this.dialogEditIcon.show().subscribe(result => {
      if (result) {
        this.facade.uploadMasterCategoryIcon(masterCategory, result);
      }
    });
  }

  public deleteIcon($event) {
    let masterCategory = <ServiceMasterCategoryModel>$event.data;

    this.facade.deleteMasterCategoryIcon(masterCategory);
  }

  public sync() {
    this.facade.sync();
  }
}
